<template>
  <v-combobox
    v-model="group"
    outlined
    dense
    hide-details="auto"
    placeholder="Select Group..."
    background-color="white"
    ref="groupSelect"
    no-filter
    return-object
    item-text="name"
    :search-input.sync="search"
    :disabled="disabled"
    :loading="runningAction"
    :items="groups"
    :rules="rules"
    data-test-id="groupSelectCombobox"
  >
    <template #no-data>
      <div class="d-flex justify-center">
        <v-subheader>{{ noDataText }}</v-subheader>
      </div>
    </template>

    <template #prepend-item>
      <div class="d-flex flex-row flex-grow-1 align-center px-2 py-1">
        <div class="text-caption">
          <strong>Matching groups for name (first 20 shown)</strong>
        </div>
      </div>
      <v-divider class="my-2" />
    </template>

    <template #item="{ item, on, attrs }">
      <v-list-item v-on="on" v-bind="attrs" dense>
        <v-list-item-title :data-test-id="'group_' + item.name">{{
          item.name
        }}</v-list-item-title>
      </v-list-item>
    </template>
  </v-combobox>
</template>

<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },

    groupId: {
      type: String,
      required: false,
    },

    rules: {
      type: Array,
      required: false,
      validator: (rules) => rules.every((rule) => typeof rule === "function"),
    },
  },

  data() {
    return {
      groups: [],
      dummyModel: this.value,
      runningAction: false,
      showHelperDialog: false,
      timeout: 0,
      group: null,
      search: null,
    };
  },

  mounted() {
    this.loadGroups();
  },

  watch: {
    search() {
      window.clearTimeout(this.timeout);
      this.timeout = window.setTimeout(() => {
        this.loadGroups();
      }, 300);
    },

    group(group) {
      this.$emit("input", group);
    },
  },

  methods: {
    async loadGroups() {
      try {
        this.runningAction = true;
        const name = this.search;
        const body = {
          offset: 0,
          limit: 20,
          name,
        };
        const response = await this.$store.$coreApi.coreUserApi.searchGroups(
          this.selectedDomain,
          body
        );
        if (!response?.ok) return;
        const responseBody = await response.json();
        const groups = responseBody?.groups ?? [];
        this.groups = groups.filter(({ id }) =>
          this.groupId ? this.groupId !== id : true
        );
      } finally {
        this.runningAction = false;
      }
    },
  },

  computed: {
    selectedDomain() {
      return this.$store.state.selectedDomain;
    },

    noDataText() {
      return "No groups found for this name";
    },
  },
};
</script>
